module.exports = __webpack_public_path__ + "img/FigmaDDSSlicePNG4a8a7e516b2af0f4fdd998d0ce5bb871.4a8a7e51.png";